import {
  ApiProperty,
  ApiPropertyOptional,
  IntersectionType,
} from '@nestjs/swagger';
import { BuilderInterface } from '../interfaces/builder.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsString, MaxLength, MinLength } from 'class-validator';
import { Exclude, Expose } from 'class-transformer';
import { ArchivableEntityDto } from '../../common/dto/archivable-entity.dto';
import { SpBuilderNameDto } from '../../sp/builder-name/dtos/sp-builder-name.dto';

@Exclude()
export class BuilderDto
  extends IntersectionType(CommonEntityDto, ArchivableEntityDto)
  implements BuilderInterface
{
  @ApiProperty({
    description: 'The code of the Builder',
  })
  @IsString()
  @MinLength(2)
  @MaxLength(100)
  @Expose()
  code!: string;

  @ApiProperty({
    description: 'The name of the Builder',
  })
  @IsString()
  @MinLength(2)
  @MaxLength(100)
  @Expose()
  name!: string;

  @ApiPropertyOptional({
    type: () => [SpBuilderNameDto],
    title: 'SpBuilderNames',
    description: 'The list of SP builder names associated with this builder.',
  })
  @Expose()
  spBuilderNames?: SpBuilderNameDto[];
}
